<template>
  <Page>
    <div class="clientCare">
      <div class="header-colum">
        <!-- 顶部栏 -->
        <div class="headerTitle-top flex">
          <div class="picker-alls " @click="showShops=!showShops">
            <div class="common-limit">{{deptName}}</div>
            <div class="triangle_border_down">

            </div>
          </div>
          <div class="flex flex-rows">
            <div v-for="(item,index)  in timeList"
                 class="item1 time-tab"
                 :class="dateType==item.id?'active':''"
                 v-bind:key="index"
                 @click="dateType=item.id"
            >{{item.name}}</div>
          </div>
        </div>
        <!-- 切换 -->
        <van-tabs v-model="active">
          <van-tab :title="'客户生日('+total1+')'"></van-tab>
          <van-tab :title="'结婚纪念日('+total2+')'"></van-tab>
        </van-tabs>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <!-- 内容版块 -->
          <div v-for="(item,index) in list" v-bind:key="index" @click="linkTo(item.accountId)">
            <card :item="item"></card>
            <!--<div class="information-list " @click="toClientDetail(item.accountId)">-->
                    <!--<div class="information-list-item item-lists flex activeFont">-->
                        <!--<div class="title-LF">姓名</div>-->
                        <!--<div>{{item.name||''}}</div>-->
                    <!--</div>-->
                    <!--<div class="information-list-item item-lists flex activeFont">-->
                        <!--<div class="title-LF">性别</div>-->
                        <!--<div>{{item.gender=='0'?'男':'女'}}</div>-->
                    <!--</div>-->
                     <!--<div class="information-list-item item-lists flex activeFont">-->
                        <!--<div class="title-LF">手机号</div>-->
                        <!--<div>{{item.mobile||''}}</div>-->
                    <!--</div>-->
                    <!--<div class="information-list-item item-lists flex activeFont">-->
                        <!--<div class="title-LF">{{item.birthday?'生日':item.weddingDate?'结婚纪念日':''}}</div>-->
                        <!--<div>{{item.birthday?item.birthday:item.weddingDate?item.weddingDate:''}}</div>-->
                    <!--</div>-->
                    <!--<div class="information-list-item item-lists flex activeFont">-->
                        <!--<div class="title-LF">VIP等级</div>-->
                                          <!--<div class="VIP-starts"  v-if="item.vip" :style="'width:'+item.vip*.4+'rem'">-->
                                                <!--<img-->
                                                      <!--v-for="(item,index) in item.vip"-->
                                                      <!--v-bind:key="index"-->
                                                      <!--:src="require('@/assets/img/vipStar.png')"-->
                                                      <!--class="start"-->
                                                      <!--alt=""-->
                                                      <!--srcset=""-->
                                                <!--&gt;-->
                                          <!--</div>-->
                    <!--</div>-->


            <!--</div>-->
            <!--<van-rate class="rate item-keep" v-model="value" readonly/>-->
          </div>
        </van-list>
      </div>

      <!-- 分页数据计算 -->
      <div class="loaded">已加载 {{this.list.length}}/{{totalRow}}</div>

      <shops v-model="showShops" @getShop="getShop"></shops>
    </div>
  </Page>
</template>





<script>
  import shops from './components/shops.vue'
  import card from './components/clientCareCard.vue'
export default {
  data() {
    return {
      timeList: [
        {
          name: "今天",
          id: 1
        },
        {
          name: "7日内",
          id: 2
        },
        {
          name: "15日内",
          id: 3
        }
      ],
      list: [],
      loading: false,
      finished: false,
      totalRow: 100,
      pageNo:1,
      pageSize:10,

      showShops:false,

      dealerId:this.$wxuserUtil.getDeptId(),
      deptName:this.$wxuserUtil.getDeptName(),//部门名字
      dateType:1,
      typesOfCare:1,
      active: 0,

      total1:0,
      total2:0

    };
  },
  components:{shops,card},
  mounted() {
       this.getList();
  },
  watch:{
    dateType:function(){
      this.initData()
    },
    active:function(){
      if(this.active==0){
          this.typesOfCare=1
      }else if(this.active==1){
        this.typesOfCare=2
      }
      this.initData()
    }
  },
  methods: {
    onLoad() {
      // 异步更新数据
    },
    initData(){
        this.loading=false
        this.finished=false
        this.totalRow=0
        this.list=[]
        this.getList()
    },
    async getList(){
      var that = this;
      var response = await  this.$api.getCustCareReport({
        salesId:that.$wxuserUtil.getUserId(),
        dateType:that.dateType,
        typesOfCare:that.typesOfCare,
        pageNumber:that.pageNo,
        pageSize:that.pageSize,
        dealerId:this.dealerId
      });
      if(response.success){
        var pageList = response.data.custList.list;
        that.list.push(...pageList);

        that.totalRow = response.data.custList.totalRow
        that.finished = response.data.custList.lastPage;
        this.total1=response.data.birthdayNumber
        this.total2=response.data.weddingDateNumber
        for(var key in that.list){
            if(that.list[key].vip){
              that.list[key].vip=parseInt(that.list[key].vip)/10
            }else{
              that.list[key].vip=0
            }
        }

      }else{
        that.$title(`获取活动列表失败,${response.msg}`);
      }
      if(!that.finished){
        that.pageNo=that.pageNo+1
      }
      that.loading = false;
    },
    getShop(e){
        if(e.deptId){
          this.dealerId=e.deptId
          this.deptName=e.deptName
        }else{
          this.dealerId=this.$wxuserUtil.getDeptId()
          this.deptName=this.$wxuserUtil.getDeptName()
        }

        this.initData()
    },
    linkTo(id){
        this.$router.push('/ClientDetails?custId='+id)
    },
   /**
     *   客户详情
     **/
    toClientDetail(ID){
      if(ID){
        this.$router.push({ path: "/ClientDetails", query: {custId:ID,showCC:true,IdCode:this.$parent.IdCode} })
      }
    },
  }
};
</script>





<style lang="less" src="~p/pageView-clientCare.less">

</style>
<style lang="less" src="~p/pageView-resportList.less">

</style>







// WEBPACK FOOTER //
// src/components/reports/clientCare.vue